import type { BadgeVariant } from "@design";
import type { FeedbackCategory } from "@/features/feedback/feedbackForm";

export type { FeedbackCategory };
export const FEEDBACK_STATUSES = ["open", "in_progress", "resolved", "closed"] as const;
export type FeedbackStatus = (typeof FEEDBACK_STATUSES)[number];

export const CATEGORY_VARIANT: Record<FeedbackCategory, BadgeVariant> = { bug: "danger", feature: "info" };

export const STATUS_VARIANT: Record<FeedbackStatus, BadgeVariant> = {
  open: "warning",
  in_progress: "info",
  resolved: "success",
  closed: "neutral",
};

export const categoryVariant = (category: string) => CATEGORY_VARIANT[category as FeedbackCategory] ?? "neutral";
export const statusVariant = (status: string) => STATUS_VARIANT[status as FeedbackStatus] ?? "neutral";
